const baseUrl: string = "https://api.covalenthq.com/v1";

export const endpointGenerator = (
    extension: string = "",
    params: {
        key: string;
        value: boolean | null | string | string[] | number | undefined;
    }[] = []
): URL => {
    extension = extension.replace(baseUrl, "");
    if (extension.startsWith("/")) {
        extension = extension.slice(1);
    }
    if (!extension.endsWith("/")) {
        extension = `${extension}/`;
    }

    const urlParams = new URLSearchParams();

    params.forEach((param) => {
        if (param.value !== undefined && param.value !== null) {
            urlParams.append(param.key, param.value.toString());
        }
    });

    return new URL(`${baseUrl}/${extension}?${urlParams}`);
};
